// Shared formatters used by the rules tables.
export function formatValue(value, key) {
  if (value === null || value === undefined) return <span style={{ color: '#ccc' }}>—</span>;
  if (typeof value === 'boolean') {
    return value
      ? <span className="badge bill"   style={{ fontSize: 10 }}>Yes</span>
      : <span className="badge remove" style={{ fontSize: 10 }}>No</span>;
  }
  if (typeof value === 'number' && !key.includes('id')) {
    return value > 0
      ? <span style={{ fontWeight: 600, color: '#155724' }}>{value}</span>
      : <span style={{ color: '#999' }}>0</span>;
  }
  return String(value);
}
